<script>
	import { popup } from "./stores";
	import { getQueryString, randomID } from "./utils.js";

	let startTime = Number(localStorage.getItem("startTime"));

	if (startTime == 0 || startTime === null) {
		startTime = +new Date();
		localStorage.setItem("startTime", startTime);
	} else {
		const currentTime = +new Date();
		const timeDiff = (currentTime - startTime) / 1000 / 60; // in mins
		const minElapsed = 180;
		console.log("Visited", timeDiff, "minutes ago");
		if (timeDiff > minElapsed) {
			console.log(
				"Visited more than",
				minElapsed,
				"minutes ago. Clearing entities to get new state.",
			);
			startTime = +new Date();
			localStorage.setItem("startTime", startTime);
			localStorage.removeItem("entities");
			localStorage.setItem("entities_engage", JSON.stringify({}));
			localStorage.setItem("intersect_events", JSON.stringify([]));
		}
	}

	let user_id = localStorage.getItem("user_id");
	let complete = Number(localStorage.getItem("complete"));
	let experiment_id = localStorage.getItem("experiment_id");
	let entities = JSON.parse(localStorage.getItem("entities"));
	let entities_engage = JSON.parse(localStorage.getItem("entities_engage"));
	let intersect_events = JSON.parse(localStorage.getItem("intersect_events"));

	if (localStorage.getItem("modalShown") === null) {
		localStorage.setItem("modalShown", "0");
	}
	localStorage.setItem("nextRoute", location.protocol + "//" + location.host);

	let queryParams = getQueryString();
	localStorage.setItem("queryParams", JSON.stringify(queryParams));
	console.log("url query parameters:", queryParams);

	// get user_id from url or localStorage or generate user_id
	let queryHasUserId = queryParams.hasOwnProperty("user_id");
	let clearEntities;
	const getUserId = () => {
		if (queryHasUserId) {
			// if user_id is in query parameters, always user query parameter user_id
			if (user_id === null) {
				clearEntities = true; // call load_feed_stimuli in Feed.svelte
				console.log(
					"Use query parameter user_id (no user_id in localStorage):",
					queryParams.user_id,
				);
			} else if (user_id !== queryParams.user_id) {
				clearEntities = true;
				console.log(
					"Overwrite user_id in localStorage",
					user_id,
					"with query parameter",
					queryParams.user_id,
				);
			} else if (user_id === queryParams.user_id) {
				clearEntities = false; // don't call load_feed_stimuli in Feed.svelte
				console.log(
					"query parameter and user_id in localStorage are identical",
					user_id,
				);
			}
			user_id = queryParams.user_id;
		} else {
			// user_id is not in query parameters
			if (user_id === null) {
				// no user_id in localStorage
				user_id = +new Date() + "_" + randomID(5);
				clearEntities = true;
				console.log("Generate new user_id:", user_id);
			} else {
				console.log("Use user_id in localStorage:", user_id);
				clearEntities = false;
			}
		}
		return user_id;
	};
	user_id = getUserId();

	const getExperimentId = () => {
		const queryExpID = queryParams.hasOwnProperty("experiment_id");
		console.log("complete", complete);
		if (queryExpID && complete === 0) {
			experiment_id = queryParams.experiment_id;
			clearEntities = true;
			console.log("Use query parameter experiment_id:", experiment_id);
		} else if (queryExpID && complete) {
			clearEntities = false;
			experiment_id = queryParams.experiment_id;
		} else if (queryExpID && experiment_id != queryParams.experiment_id) {
			clearEntities = true;
			experiment_id = queryParams.experiment_id;
		} else if (experiment_id == "solarflare" && !queryExpID) {
			// no experiment_id in queryParams
			clearEntities = false;
			console.log("Use default experiment_id:", experiment_id);
		}

		if (experiment_id === undefined || experiment_id === null) {
			clearEntities = true;
			experiment_id = "solarflare";
			console.log("Use default experiment_id:", experiment_id);
		}
		localStorage.setItem("experiment_id", experiment_id);
		return experiment_id;
	};
	experiment_id = getExperimentId();

	if (clearEntities) {
		console.log("Clear localStorage entities: calling load_feed_stimuli");
		localStorage.removeItem("entities");
		localStorage.setItem("entities_engage", JSON.stringify({}));
		localStorage.setItem("intersect_events", JSON.stringify([]));
	}

	localStorage.setItem("user_id", user_id);
	localStorage.setItem("experiment_id", experiment_id);

	if (entities_engage === null) {
		localStorage.setItem("entities_engage", JSON.stringify({}));
		localStorage.setItem("intersect_events", JSON.stringify([]));
	}

	// re-show popup modal again only after time_mins mins have elapsed
	const time_mins = 0.0001;
	if (clearEntities) {
		localStorage.removeItem("popupTime");
	}
	let popupTime = localStorage.getItem("popupTime");
	if (popupTime === null) {
		popupTime = +new Date();
		localStorage.setItem("popupTime", popupTime);
		popup.set(true);
	} else {
		const currentTime = +new Date();
		if (currentTime - popupTime > 1000 * 60 * time_mins) {
			popupTime = currentTime;
			localStorage.setItem("popupTime", popupTime);
			popup.set(true);
		} else {
			popup.set(false);
		}
	}
</script>
